/**
 * Construit le payload à envoyer depuis les valeurs du form et la fileList Upload.
 * - birthdate -> ISO string
 * - avatar -> File (ou null)
 */
export default function makeEditPayload(values = {}, fileList = []) {
    const imageFile =
      Array.isArray(fileList) && fileList.length > 0
        ? fileList[0]?.originFileObj || null
        : null;
  
    const toIso = (d) => {
      if (!d) return null;
      // d peut être un dayjs, une Date, ou une string
      if (typeof d?.toDate === "function") return d.toDate().toISOString();
      if (d instanceof Date) return d.toISOString();
      const parsed = new Date(d);
      return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
    };
  
    return {
      ...values,
      birthdate: toIso(values.birthdate),
      avatar: imageFile || null,
    };
  }
  